import React, { FC, useCallback, useState } from 'react';
import { TouchableOpacity } from 'react-native';
import Icon from 'react-native-vector-icons/MaterialIcons';
import { useDispatch, useSelector } from 'react-redux';

import { formFieldValueSelector } from '@common/redux/selectors/formInputs';
import { setFormValue } from '@common/redux/slice/formInputs';
import { ICheckBox } from '@common/types/element';

const Checkbox: FC<ICheckBox> = (attributes) => {
  const dispatch = useDispatch();
  const { id } = attributes;
  const [state] = useState({
    activeColor: attributes?.activeColor || '',
    inactiveColor: attributes?.inactiveColor || '',
    activeIcon: attributes?.activeIcon || 'check-box',
    inactiveIcon: attributes?.inactiveIcon || 'check-box-outline-blank',
  });

  const valueInputs = useSelector(formFieldValueSelector(id)) || false;
  const changeValue = useCallback(
    (value: any) => {
      dispatch(setFormValue({ [id]: value }));
    },
    [dispatch, id]
  );

  return (
    <TouchableOpacity
      onPress={() => {
        changeValue(!valueInputs);
      }} //{() => changeValue(id, !value)}
      activeOpacity={0.4}
      hitSlop={{ left: 10, right: 10, top: 10, bottom: 10 }}
      //   style={layout}
    >
      <Icon
        size={24}
        name={valueInputs ? state.activeIcon : state.inactiveIcon}
        color={valueInputs ? state.activeColor : state.inactiveColor}
      />
    </TouchableOpacity>
  );
};

export default Checkbox;
